define('TescoMobile_Checkout/js/view/quote/login-quote-modal',['uiComponent', 'jquery', 'ko', 'mage/url', 'Magento_Ui/js/modal/confirm', 'Magento_Customer/js/customer-data', 'mage/translate'], function (Component, $, ko, urlBuilder, confirmModal, customerData, $t) {
  'use strict';

  return Component.extend({
    modalWindow: null,
    isLoading: ko.observable(true),
    messages: ko.observableArray(),
    initialize: function () {
      var self = this;
      this._super();
      var customer = customerData.get('customer');
      if (!!customer.firstname) {
        this.getQuoteValidationResult();
      }
      customerData.get('customer').subscribe(function (data) {
        if (data.firstname) {
          this.getQuoteValidationResult();
        }
      }, this);
    },
    getQuoteValidationResult: function () {
      var self = this;
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/getQuoteValidationResult'),
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          if (result && result.code === 'pending-order') {
            confirmModal({
              title: $t('You almost finished an order earlier'),
              buttons: [{
                text: $t('Finish previous order'),
                click: function () {
                  window.location.href = urlBuilder.build('checkout/');
                }
              }, {
                text: $t('Delete previous order'),
                click: function (event) {
                  this.closeModal(event, true);
                  self.cancelPendingOrder(result.data);
                }
              }]
            });
          } else if (result && self.showChangeDealModal(result.code)) {
            $('body').trigger('dl-one-deal-view-' + result.code);
            confirmModal({
              title: result.message,
              content: result.info,
              modalClass: 'confirm-popup',
              clickableOverlay: false,
              buttons: [{
                text: $t('Keep my new basket'),
                class: 'action primary',
                click: function (event) {
                  $('body').trigger('dl-one-deal-change-' + result.code);
                  self.changeDeal(result, event, this);
                }
              }, {
                text: $t('Restore my previous basket'),
                class: 'action secondary',
                click: function (event) {
                  $('body').trigger('dl-one-deal-keep-' + result.code);
                  this.closeModal(event, true);
                }
              }]
            });
          } else if (result && self.showLimitWarningModal(result.code)) {
            confirmModal({
              title: $t('Warning'),
              content: result.message,
              clickableOverlay: false,
              buttons: [{
                text: $.mage.__('Ok'),
                class: 'action primary',
                click: function (event) {
                  this.closeModal(event, true);
                }
              }]
            });
          }
        },
        complete: function (result) {
          self.isLoading(false);
        }
      });
    },
    changeDeal: function (result) {
      let event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      let modal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var self = this;
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/changeDealInCart'),
        data: {
          'masked_quote_id': result.data
        },
        type: 'post',
        dataType: 'json',
        cache: false,
        complete: function (result) {
          self.isLoading(false);
          if (event && modal) {
            modal.closeModal(event, true);
          }
        }
      });
    },
    cancelPendingOrder: function (orderId) {
      var self = this;
      this.isLoading(true);
      $.ajax({
        url: urlBuilder.build('checkout/cart/cancelpendingorder'),
        data: {
          'order_id': orderId
        },
        type: 'post',
        dataType: 'json',
        cache: false,
        success: function (result) {
          if (result.error === false) {
            self.isLoading(false);
          } else {
            self.isLoading(false);
            confirmModal({
              title: $t('Sorry, we were unable to cancel your order.'),
              clickableOverlay: true,
              buttons: [{
                text: $.mage.__('Ok'),
                click: function (event) {
                  this.closeModal(event, true);
                }
              }]
            });
          }
        }
      });
    },
    showChangeDealModal: function (code) {
      return code === 'upgrade' || code === 'migrate';
    },
    showLimitWarningModal: function (code) {
      return code === 'overdue-balance' || code === 'pending-deactivate' || code === 'address-changed-recently' || code === 'limit' || code === 'error';
    }
  });
});

